<template>
  <div class="serviceView">
    <div class="banner">
      <div class="title">
        <div>{{ S.banner }}</div>
      </div>
    </div>
    <div class="service">
      <div class="contant">
        <div class="contant-left">
          <div class="title">
            {{ S.present[num].big_title }}
          </div>
          <div class="text">
            {{ S.present[num].big_subTitle }}
          </div>
          <div class="img">
            <img :src="S.present[num].img4" alt="" />
          </div>
        </div>
        <div class="contant-right">
          <div class="one" v-for="(e, i) in S.present[num].ocean" :key="i">
            <div class="title" v-if="e.title">
              {{ e.title }}
            </div>
            <div class="text">
              <p v-for="(item, index) in e.arr" :key="index" v-html="item">
                {{}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="select">
      <div class="title">{{ S.choose }}</div>
      <div class="subTitle">
        <!--  -->
        <div
          class="box "
          :class="[tabindex == i ? 'active' : '', `box${i * 1 + 1}`]"
          @mouseenter="tabindex = i"
          v-for="(e, i) in S.choose_for"
          :key="i"
        >
          <div class="num">{{ i + 1 }}</div>
          <div class="titles">{{ e.title }}</div>
          <div class="text">
            {{ e.text }}
          </div>
        </div>
      </div>
      <div class="img">
        {{ S.partners }}
      </div>
      <div class="logo">
        <img  src="../../static/img/logo100.png" alt="" />
      </div>
      <!-- <div class="logo">
        <div class="icon  ">
          <img class="icon1" src="../../static/img/logo1.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon2" src="../../static/img/logo2.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon3" src="../../static/img/logo3.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon4" src="../../static/img/logo4.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon5" src="../../static/img/logo5.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon6" src="../../static/img/logo6.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon7" src="../../static/img/logo7.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon8" src="../../static/img/logo8.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon9" src="../../static/img/logo9.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon10" src="../../static/img/logo10.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon11" src="../../static/img/logo11.png" alt="" />
        </div>
        <div class="icon  ">
          <img class="icon12" src="../../static/img/logo12.png" alt="" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import moveArr from "../../static/movedata/services";
import text from "../../static/data/text";
export default {
  data() {
    return {
      num: 0,
      lan: "cn",
      tabindex: 0,
      allTimeline: null
    };
  },
  computed: {
    S() {
      return text[this.lan]["service"];
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  created() {
    let routerid = this.$route.query.num;
    if (routerid) {
      this.num = routerid;
    }
  },
  watch: {
    $route: {
      handler(newV, oldV) {
        this.num = newV.query.num;
      },
      immediate: true
    }
  },
  mounted() {
    if (document.body.style.zoom > 0.95) {
      window.addEventListener("scroll", this.scrollToTop, true);
      this.initaniE();
    }
  },
  methods: {
    initaniE() {
      this.allTimeline = new TimelineMax({ paused: true });
      let scrollAnimationObj = moveArr;
      for (let i = 0; i < scrollAnimationObj.length; i++) {
        let bwTimeline = new TimelineMax({
          delay: scrollAnimationObj[i].distancetop / 3285
        });
        let bwTween = TweenMax.fromTo(
          scrollAnimationObj[i].ele,

          scrollAnimationObj[i].distancebottom / 3285,
          scrollAnimationObj[i].from,
          scrollAnimationObj[i].to
        );
        bwTimeline.add(bwTween, 0);
        this.allTimeline.add(bwTimeline, 0);
      }
    },
    scrollToTop() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      this.allTimeline.seek(scrollTop / 3285);
    }
  }
};
</script>

<style scoped>
.banner {
  height: 565px;
  position: relative;
  overflow-x: hidden;
  line-height: 0;
  background: url("/static/img/service/banner.png") no-repeat fixed;
}
.banner .title {
  text-align: center;
  margin: 225px auto 0;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  padding: 0 520px;
}
.banner .title div {
  padding: 74px 0;
  border-top: 2px solid rgba(255, 255, 255, 0.3);
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 87px;
}

/* service */
.service {
  background: #3472ef;
  position: relative;
}
.service .contant {
  padding: 149px 187px 109px 287px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.service .contant-left .title {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 87px;
  text-align: center;
}
.service .contant-left .text {
  font-size: 21px;
  font-family: Source Han Sans CN-Light, Source Han Sans CN;
  font-weight: 300;
  color: #ffffff;
  line-height: 28px;
  letter-spacing: 10px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 31px;
}
.service .contant-left .img {
  position: absolute;
  left: -67px;
  bottom: -214px;
  transition: all 0.3s;
}
.service .contant-left .img img {
  width: 830px;
  height: 776px;
}
.service .contant-right {
  width: 773px;
  height: 704px;
  font-size: 25px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 45px;
  transition: all 0.2s;
}
.service .contant-right .one .text {
  margin-bottom: 12px;
}

/* select */
.select {
  background: #fff;
}
.select .title {
  width: 520px;
  height: 87px;
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  line-height: 87px;
  margin-left: 948px;
  margin-top: 123px;
}

.select .subTitle {
  margin-top: 164px;
  display: flex;
  padding: 0 287px 0 255px;
  justify-content: space-between;
}
.select .subTitle .box {
  width: 400px;
  padding-bottom: 44px;
  cursor: pointer;
  transition: all 0.5s;
}
.select .subTitle .box.active {
  border-bottom: 3px solid #3472ef;
}
.select .subTitle .box .num {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ffffff;
  border: 3px solid #000000;
  line-height: 64px;
  text-align: center;
  font-size: 28px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
}
.select .subTitle .box .titles {
  margin-top: 56px;
  font-size: 35px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  line-height: 32px;
  margin-bottom: 22px;
}
.select .subTitle .box .text {
  font-size: 28px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  line-height: 47px;
}
.select .subTitle .active .num {
  background: #3472ef;
  color: #fff;
  border: none;
}

.select .img {
  background: url("../../static/img/service/select.png") no-repeat center center;
  margin-left: 287px;
  margin-top: 149px;
  height: 367px;
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 367px;
  padding-left: 158px;
  transition: all 0.5s;
}

.select .logo {
  display: flex;
  flex-wrap: wrap;
  margin-top: 107px;
  /* padding: 0 595px 0 441px; */
  padding: 46px 0 10px 0;
  /* justify-content: space-between; */
  margin-bottom: 149px;
  transition: all 0.5s;
  margin-left: 247px;
  margin-right: 247px;
}
.select .logo .icon {
  font-size: 77px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #b8b8b8;
  /* margin-right: 118px; */
  text-align: center;
}

.logo {
  display: flex;
  flex-wrap: wrap;
  margin-top: 107px;
  justify-content: space-between;
  padding: 46px 0 10px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  transition: all 0.5s;
}
.select .logo .icon.active {
  color: #3472ef;
}
.select .logo .icon:nth-of-type(3) {
  margin-right: 0;
}
.select .logo .icon:nth-of-type(6) {
  margin-right: 0;
}
.icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon {
  width: 223px;
}
.icon1 {
  width: 107px;
}
.icon2 {
  width: 104px;
}
.icon3 {
  width: 128px;
}
.icon4 {
  width: 128px;
}
.icon5 {
  width: 110px;
}
.icon6 {
  width: 127px;
}
.icon7 {
  width: 132px;
}
.icon8 {
  width: 249px;
}
.icon9 {
  width: 211px;
}
.icon10 {
  width: 124px;
}
.icon11 {
  width: 85px;
}
.icon12 {
  width: 105px;
}
img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/service.vue